/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { AppModal } from '../state/modal';
import { SettingsModal } from './SettingsModal';
import { ReconstructionParamModal } from './ReconstructionParamModal';
import { useModal } from '../state/modal';

export const Modals = () => {
  const { param, dismiss } = useModal();

  return (
    <>
      <SettingsModal visible={param === AppModal.Settings} onDismiss={dismiss} />
      <ReconstructionParamModal visible={param === AppModal.ReconstructionParams} onDismiss={dismiss}/>
    </>
  );
};
